var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.roles == 'AdmAgent')?_c('Transacting'):_vm._e(),(
            _vm.$store.state.roles == 'AdmSupervisor' ||
                _vm.$store.state.roles == 'Administrator' ||
                _vm.$store.state.roles == 'AdministrationPpW'
        )?_c('TransactingAdmin'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }